const options = {
  5: "bg-green-300/5",
  10: "bg-green-300/10",
  25: "bg-green-300/25",
  50: "bg-green-300/50",
  75: "bg-green-300/75",
  90: "bg-green-300/90",
  100: "bg-green-300",
};

const from = {
  5: "from-green-300/5",
  10: "from-green-300/10",
  25: "from-green-300/25",
  50: "from-green-300/50",
  75: "from-green-300/75",
  90: "from-green-300/90",
  100: "from-green-300",
};

export default function getBackgroundGreen300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
